function unique(value: string | number, index: number, self: Array<string | number>) {
  return self.indexOf(value) === index;
}

export default unique;
